export default {
  common: {
    operation_success: "Operation completed successfully",
    success_add: "Successfully added",
    success_remove: "Successfully removed",
    logout: "Logout",
    test: "Test",
    edit: "Edit",
    upload: "Upload",
    remove: "Remove",
    save: "Save",
    cancel: "Cancel",
    example: 'Example',
    site: "Site",
    is_enabled: "Enabled",
    is_disabled: "Disabled",
    copy: "Copy",
    text_has_been_copied_to_clipboard: "Text has been copied to clipboard",
    legal_name: "Legal name",
    inn: "ИНН",
    kpp: "КПП",
    address: "Address",
    company_details: "Company details",
    success_register: "Registration complete. New account was successfully registered. "
  },
  sites: {
    title: "Sites",
    add_site: "Add site",
    domain: "Domain",
    identifier: "Identifier",
    landing_page: "Landing page",
    catalog_header: "Catalog header",
    catalog_title:"Catalog title",
    breadcrumbs:"Hide breadcrumbs",
    link_to_site_in_breadcrumbs: "Hide link to site in breadcrumbs",
    add_custom_css_file: "Add custom CSS file",
    landing_page_part_number_definition: '- is replaced by the part number from the catalog (must be used)',
    landing_page_brand_definition: '- replaced by the brand of the spare part from the catalog (optional)',
    landing_page_example: "landing page example",
    landing_page_example_bremi_12345: "landing page if you choose part Bremi 12345 in the catalog",
  },
  catalogs_groups: {
    title: "Catalogs groups",
    catalog:"Каталог",
    link_to_catalog: "Link to the catalog",
    code_for_site: "Code for insertion on the site",
    iframe_code: "Code for IFrame",
    insert_a_link_to_the_catalog: "Insert a link to the catalog"
  },
  payments: {
    original_catalog_service: "Original catalog service",
    special_catalog_service: "Special catalog service",
    select_all_with_discount:"Choose all with discount",
    title: "Payments",
    catalog_group: "Catalog group",
    rent_period: "Rental period",
    hide_footer: "Hide footer",
    price_per_month: "Price per month",
    status: "Current status",
    sum: "Sum",
    total_sum: "Total sum",
    per_month: "per month",
    pay: "Pay",
    card: "Credit card",
    invoice: "Invoice",
    payment_type: "Payment type",
    error_choose_payment_type: "You should choose payment type!",
    payment_success: "Payment successfully completed",
    payment_failed: "Payment error",
  },
  support: {
    title: "Support"
  },
  docs: {
    title: "Documentation"
  },
  passwordRecovery:{
    email: "Your e-mail",
    title: "Password recovery",
    success_text: "The password has been sent to the specified email address",
    recovery: "Recovery"
  },
  form: {
    login: {
      title: "Authorization",
      email: "E-mail",
      password: "Password",
      password_confirmation: "Password confirmation",
      login: "Login",
      register:"Register",
      forgot_password: "Password recovery",
      name: "Name",
    },
    validationErrors: {
      field_is_required: "Required field",
      min_length: "The length must be more then {0} symbols",
      must_be_greater: "Must be more than {0}",
      field_must_be_contain: "Must be contain {0}",
      password_confirmation_doesnt_match: "Password confirmation doesn't match password",
      email_not_valid: "Must be valid e-mail",
    },
    confirmation:{
      success_title: "You are successfully confirm your e-mail",
      title: "To continue working with the service, please confirm your e-mail",
      resend_code: "Resend confirmation code",
      send_code: "Send confirmation code",
      code_label: "Code from email"
    }
  },
};
